import React, { useState, useRef } from 'react';
import Header from './views/header'
import sorteo from './views/sorteo'
import MenuMain from './views/MenuMain';
import MenuExtender from './views/MenuExtender';
import Main from './views/main';
import Top from './views/top'
import Redes from './views/redes'

import Games from './views/games';
import LoginOnProgress from './views/loginOnProgress';
import LoginYoutubeOnProgress from './views/loginYoutubeOnProgress';
import LinkPage from './views/LinkPage'
import UserSearch from './views/UserSearch'
import AdminLogin from './views/adminLogin';
import AdminPanel from './views/adminPanel';
import Commands from './views/commands';
import Codigos from './views/codigos';
// User
import User from './views/user';
import Rewards from './views/rewards';
import Overbox from './views/Overbox';
import Missions from './views/Missions';
import Settings from './views/Settings';
import DonationsInfo from './views/Overbox';
//
import Info from './views/info';
import Login from './views/login';
import './App.css';
import { BrowserRouter as Router, Route, Routes, Navigate, useLocation } from 'react-router-dom';
import { DndContext } from '@dnd-kit/core';
import PopUp from './views/PopUp';
import EconomyBox from './views/components/economyBox';
import PrivacyPolicy from './views/components/privacyPolicy';
import DataDeletion from './views/components/dataDeletion';
import CookieBanner from './views/components/CookieBanner';
import WelcomeTutorial from './views/components/WelcomeTutorial';
import Tutorial from './views/components/Tutorial';
import ClickParticles from './views/components/ClickParticles';
import Spinner from './views/components/Spinner';
import { setReturnTo } from './utils/sessionUtils';
//Gadgets
import StreamTimeCounter from './views/streamTimeCounter';
import RewardsHistory from './views/rewardsHistory';
import FanPointsToday from './views/fanPointsToday';
import ApuestasFront from './views/components/apuestasFront';
import LeagueOverlay from './views/leagueOverlay';
import Chat from './views/chat';
import Torneos, { TorneoOverlay } from './views/torneos';
import Cola from './views/cola';
// Images
import biruxOro112 from './views/images/biruxOro112.png';

function ProtectedRoute({ isAuthenticated, loading, children }) {
  const location = useLocation();
  // Mientras no sepamos si hay sesión no redirigimos: si no, cualquier enlace
  // directo a /myAccount/* rebota a /myAccount y pierde el query string.
  if (loading) {
    return <Spinner />;
  }
  if (!isAuthenticated) {
    // Lo mandamos al login, pero recordamos a dónde iba para devolverlo ahí
    // (con su ?search=) en cuanto se conecte.
    setReturnTo(location.pathname + location.search);
    return <Navigate to="/myAccount" replace />;
  }
  return children;
}

const App = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [adminLoading, setAdminLoading] = React.useState(true);
  const [userPlayer, setUserPlayer] = React.useState(false);
  // Con que se logueo la sesion ('twitch' | 'youtube'), para el avatar del menu.
  const [authPlatform, setAuthPlatform] = React.useState(null);
  const [overInfo, setOverInfo] = React.useState(false);
  const [biruxBronce, setBiruxBronce] = React.useState(0);
  const [overBox, setOverBox] = React.useState(0);
  const [miniOverbox, setMiniOverbox] = React.useState(0);
  const [biruxOro, setBiruxOro] = React.useState(0);
  const [biruxComodin, setBiruxComodin] = React.useState(0);
  const [dailyWebOverbox, setDailyWebOverbox] = React.useState(false);
  const queryParameters = new URLSearchParams(window.location.search);
  const streamGadgets = queryParameters.get("streamGadgets");
  const streamTimeCounter = queryParameters.get("streamTimeCounter");

  React.useEffect(() => {
    // Los gadgets viven en browser sources de OBS: fuera el hueco de la barra de scroll
    // de html (App.css). El CEF de OBS (Chromium 127) no lo descuenta en los position:
    // fixed pero si lo tapa, asi que se comia los ultimos 15px del overlay.
    if (streamGadgets || streamTimeCounter == 1) {
      document.documentElement.style.scrollbarGutter = 'auto';
    }
    if (streamTimeCounter == 1) {
      document.documentElement.style.backgroundColor = 'rgba(24, 26, 31, 0.6)';
      document.body.style.overflow = 'hidden';
    }
  }, []);

  React.useEffect(() => {
    handleAuth(false);
    const interval = setInterval(() => {
      handleAuth(true);
    }, 3000);
    window.addEventListener('scroll', () => {
      if (document.getElementById('menu')) {
        if (document.documentElement.scrollTop > 100) { document.getElementById('menu').style.display = 'none'; }
        if (document.documentElement.scrollTop < 80) { document.getElementById('menu').style.display = 'flex'; }
      }
    })
  }, []);

  React.useEffect(() => {
    (async () => {
      try {
        const res = await fetch('/api/admin/check', {
          method: 'GET',
          credentials: 'include',
        });
        const data = await res.json();
        if (data.authenticated) {
          setUser([data.userName, true]);
        }
      } catch (error) {
        console.error('Error in admin check:', error);
      } finally {
        setAdminLoading(false);
      }
    })();
  }, []);

  React.useEffect(() => {
    if (sessionStorage.getItem('sessionExpired') === '1') {
      sessionStorage.removeItem('sessionExpired');
      setOverInfo({
        title: 'Sesión caducada',
        description: <>Tu sesión ha caducado. Por favor, inicia sesión de nuevo para continuar.</>,
        button: () => setIsDropped(false),
        buttonText: <><h3>OK</h3></>
      });
      setIsDropped(true);
    }
  }, []);



  async function handleAuth(onlyBirux) {
    try {
      const res = await fetch('/api/auth/check', {
        method: 'GET',
        credentials: 'include',
      });
      const data = await res.json();

      if (!onlyBirux) {
        setIsAuthenticated(data.authenticated);
      }
      if (data.user) {
        setBiruxBronce(data.user.birux);
        setOverBox(data.user.overbox);
        setMiniOverbox(data.user.miniOverbox || 0);
        setBiruxOro(data.user.biruxOro);
        setBiruxComodin(data.user.biruxComodin || 0);
        setDailyWebOverbox(data.user.dailyWebOverbox || false);
        if (data.user.alerts && data.user.alerts.sub && isDropped == false) {
          setIsDropped(true);
          setOverInfo({
            title: '¡Gracias por suscribirte!',
            description: <>Has obtenido 1 <img src={biruxOro112} alt="Birux dorado"></img> para gastar en la tienda!</>,
            button: () => {
              fetch('/api/alerts?action=update&type=sub&userid=' + data.user._id, {
                method: 'POST',
              })
                .then(res => res.json())
                .then(data => {
                  setIsDropped(false);
                })
            },
            buttonText: <><h3>OK</h3></>
          });
        }
        if (!onlyBirux) {
          setUserPlayer(data.user);
          setAuthPlatform(data.platform);
        }
      }
      setLoading(false);
    } catch (error) {
      console.error('Error in handleAuth:', error);
    }
  }

  // Las misiones viven aqui porque las pintan dos sitios: su pagina y el numero del menu.
  const [missions, setMissions] = React.useState([]);
  async function fetchMissions() {
    try {
      const res = await fetch('/api/missions', {
        method: 'GET',
        credentials: 'include',
      });
      const data = await res.json();
      if (data.success) {
        setMissions(data.missions);
      }
      return data;
    } catch (error) {
      console.error('Error fetching missions:', error);
    }
  }

  const [isDropped, setIsDropped] = useState(false);
  const [isPosition, setPosition] = useState({
    left: 0,
    top: 0
  });
  function handleDragStart(event) {
    if (event.active.id == 'draggable') {
      document.getElementById('overImg').classList.remove('over');
    }
  }
  function handleDragEnd(event) {
    if (event.over && event.over.id) {
      if (event.over) {
        setIsDropped(true);
        setPosition({
          left: event.delta.x + isPosition.left,
          top: event.delta.y + isPosition.top
        })
      } else {
        setIsDropped(false);
      }
      let requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ id: event.over.id })
      };
      fetch('/api/overInfo', requestOptions)
        .then(response => response.json())
        .then(data => {
          if (data) {
            setOverInfo(data);
            if (event.over && event.over.id === data.id) {
              setIsDropped(true);
              setPosition({
                left: event.delta.x + isPosition.left,
                top: event.delta.y + isPosition.top
              })
            } else {
              setIsDropped(false);
            }
          }
        })
    } else if (event.active.id == 'draggable') {
      setTimeout(() => {
        document.getElementById('overImg').classList.add('over');
      }, 1000);
    }
  }

  if (streamGadgets) {
    return (<>
      <Router>
        {streamGadgets == 'streamTimeCounter' ? <StreamTimeCounter /> : ''}
        {streamGadgets == 'rewardsHistory' ? <RewardsHistory stream={0} /> : ''}
        {streamGadgets == 'rewardsHistoryStream' ? <RewardsHistory stream={1} /> : ''}
        {streamGadgets == 'rewardsAlertStream' ? <RewardsHistory stream={2} /> : ''}
        {streamGadgets == 'fanPointsToday' ? <FanPointsToday /> : ''}
        {streamGadgets == 'bets' ? <ApuestasFront /> : ''}
        {streamGadgets == 'leagueOverlay' ? <LeagueOverlay /> : ''}
        {streamGadgets == 'chat' ? <Chat /> : ''}
        {streamGadgets == 'actividad' ? <Chat activity /> : ''}
        {streamGadgets == 'torneo' ? <TorneoOverlay /> : ''}
        {streamGadgets == 'cola' ? <Cola /> : ''}
      </Router>
    </>)
  }

  if (streamTimeCounter == 1) {
    return (
      <>
        <Router>
          <StreamTimeCounter />
        </Router>
      </>
    )
  }
  /*
* Renderizado de cada componente.
*/
  return (
    <>
      <DndContext
        onDragStart={handleDragStart}
        onDragEnd={handleDragEnd}
      >
        <Router>
          <CookieBanner>
            <WelcomeTutorial isAuthenticated={isAuthenticated} loading={loading} />
            <Tutorial isAuthenticated={isAuthenticated} />
          </CookieBanner>
          <ClickParticles faccion={isAuthenticated && userPlayer ? userPlayer.faccion : null} />
          {isDropped ? <PopUp setIsDropped={setIsDropped} setPosition={setPosition} overInfo={overInfo} /> : ''}
          {isAuthenticated && isDropped && userPlayer && userPlayer.alerts && userPlayer.alerts.sub ? <PopUp setIsDropped={setIsDropped} setPosition={setPosition} overInfo={overInfo} /> : ''}
          <Header left={isPosition.left} top={isPosition.top} isDropped={isDropped} />
          {isAuthenticated ? <EconomyBox birux={biruxBronce} overBox={overBox + miniOverbox}biruxOro={biruxOro} biruxComodin={biruxComodin} /> : ''}
          <MenuExtender />
          <MenuMain accountImage={(userPlayer && ((authPlatform === 'youtube' ? userPlayer.youtubeImage : userPlayer.twitchImage) || userPlayer.twitchImage || userPlayer.youtubeImage)) || false} faccion={userPlayer && userPlayer.faccion} isAuthenticated={isAuthenticated} missions={missions} fetchMissions={fetchMissions} />
          <Routes>
            <Route path="/" exact element={<Main isAuthenticated={isAuthenticated} loading={loading} />} />
            <Route path="/user/:username" element={<User />} />
            <Route path="/user" element={<UserSearch />} />
            <Route path="/top" element={<Top />} />
            <Route path="/link/" element={<LinkPage />} />
            <Route path="/games" element={<Games />} />
            <Route path="/sorteo" component={sorteo} />
            <Route path="/redes" element={<Redes />} />
            <Route path="/info" element={<Info />} />
            <Route path="/info/donations" element={<DonationsInfo />} />
            <Route path="/info/commands" element={<Commands />} />
            <Route path="/info/torneos" element={<Torneos />} />
            {/* /codigos/<clave> pinta ese codigo como destacado: es el enlace que sueltan los comandos del chat. */}
            <Route path="/codigos/:code?" element={<Codigos setIsDropped={setIsDropped} setOverInfo={setOverInfo} isAuthenticated={isAuthenticated} loading={loading} />} />
            <Route path="/LoginOnProgress" element={<LoginOnProgress connecting={true} loginFunc={handleAuth} />} />
            <Route path="/LoginYoutubeOnProgress" element={<LoginYoutubeOnProgress loginFunc={handleAuth} />} />
            <Route path="/myAccount" element={!userPlayer && !isAuthenticated ?
              loading ? <LoginOnProgress />
                : <Login /> : <User userPlayer={userPlayer} isAuthenticated={isAuthenticated} authPlatform={authPlatform} />} />
            {/* key distinta: las dos rutas pintan el mismo componente y, sin ella, React reutiliza
                la instancia al pasar de una a otra y el inventario hereda la lista de la tienda. */}
            <Route path="/myAccount/shop" element={<ProtectedRoute isAuthenticated={isAuthenticated} loading={loading}><Rewards key="shop" userPlayer={userPlayer} authPlatform={authPlatform} handleAuth={handleAuth} type={'shop'} setIsDropped={setIsDropped} setOverInfo={setOverInfo} /></ProtectedRoute>} />
            <Route path="/myAccount/rewards" element={<ProtectedRoute isAuthenticated={isAuthenticated} loading={loading}><Rewards key="rewards" userPlayer={userPlayer} authPlatform={authPlatform} type={'rewards'} handleAuth={handleAuth} setIsDropped={setIsDropped} setOverInfo={setOverInfo} /></ProtectedRoute>} />
            <Route path="/myAccount/overbox" element={<ProtectedRoute isAuthenticated={isAuthenticated} loading={loading}><Overbox overBox={overBox} miniOverbox={miniOverbox} dailyWebOverbox={dailyWebOverbox} handleAuth={handleAuth} hasTwitch={!!(userPlayer && userPlayer.usert)} /></ProtectedRoute>} />
            <Route path="/myAccount/missions" element={<ProtectedRoute isAuthenticated={isAuthenticated} loading={loading}><Missions handleAuth={handleAuth} missions={missions} fetchMissions={fetchMissions} /></ProtectedRoute>} />
            <Route path="/myAccount/settings" element={<ProtectedRoute isAuthenticated={isAuthenticated} loading={loading}><Settings /></ProtectedRoute>} />
            <Route path="/adminLogin" element={adminLoading ? <LoginOnProgress /> : (user.length > 0 && user[1] ? <AdminPanel user={user} /> : <AdminLogin setUser={setUser} />)} />
            <Route path='/privacy' element={<PrivacyPolicy />} />
            <Route path='/dataDeletion' element={<DataDeletion />} />
            <Route component={() => (<h1>ERROR 404</h1>)} />
          </Routes>
        </Router>
      </DndContext>
    </>
  )


}
export default App;
